
import { TestimonialCard } from "@/components/TestimonialCard";
import { SectionTitle } from "@/components/SectionTitle";

interface ServiceTestimonialsProps {
  testimonials: Array<{
    name: string;
    comment: string;
    rating: number;
    image?: string;
  }>;
  title?: string;
  subtitle?: string;
}

export const ServiceTestimonials = ({ testimonials, title, subtitle }: ServiceTestimonialsProps) => {
  return (
    <section className="py-16">
      <div className="container-custom">
        {(title || subtitle) && (
          <SectionTitle
            title={title || "What Our Patients Say"}
            subtitle={subtitle || "Real Experiences from Our Dental Clinic"}
          />
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard
              key={index}
              name={testimonial.name}
              comment={testimonial.comment}
              rating={testimonial.rating}
              image={testimonial.image || "/placeholder.svg"}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
